import Vue from "vue";
import Vuex from "vuex";
import jwt from "jwt-simple";
import axios from "./../axios-auth";
import router from "./../router/index";
import discuount from "@/store/modules/discount";
import user from "@/store/modules/user";
import postulation from "@/store/modules/postulation";
import moment from "moment";
moment.locale("es-do");

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    usuario: {},
    usuarioMenor: {},
    lastCourse: {},
    defaultSection: {},
    statusCourse: {
      statusCase2: process.env.VUE_APP_STATUS_CASE_2,
      statusCase3: process.env.VUE_APP_STATUS_CASE_3,
      statusCase4: process.env.VUE_APP_STATUS_CASE_4,
      statusCase5: process.env.VUE_APP_STATUS_CASE_5,
      statusCase6: process.env.VUE_APP_STATUS_CASE_6,
      statusCase7: process.env.VUE_APP_STATUS_CASE_7,
      statusCase8: process.env.VUE_APP_STATUS_CASE_8,
      statusCase9: process.env.VUE_APP_STATUS_CASE_9,
      statusCase10: process.env.VUE_APP_STATUS_CASE_10,
      statusCase14: process.env.VUE_APP_STATUS_CASE_14
    },
    statusModeButton: process.env.VUE_APP_STATUS_MODE_BUTTON,
    statusModeText: process.env.VUE_APP_STATUS_MODE_TEXT,
    secretKeyJwt: process.env.VUE_APP_JWT_TOKEN_KEY,
    tokenPayzen: null,
    bankPay: false,
    notifications: [],
    phone: ""
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUsuarioMenor(state, usuarioMenor) {
      state.usuarioMenor = usuarioMenor;
    },
    setPhone(state, phone) {
      state.phone = phone;
    },
    setUsuario(state, usuario) {
      state.tokenPayzen = null;
      state.usuario = usuario;
    },
    addPropToDefaultSection(state, prop) {
      // console.log(state.defaultSection);
      // console.log(prop);
      // state.defaultSection = Object.assign(state.defaultSection, prop)
      state.defaultSection = { ...state.defaultSection, ...prop };
      // state.defaultSection = Object.assign({}, state.defaultSection, prop)
    },
    setTokenPayzen(state, tokenPayzen) {
      state.tokenPayzen = tokenPayzen;
    },
    setBankPay(state, bankPay) {
      state.bankPay = bankPay;
    },
    setNotifications(state, notifications) {
      state.notifications = notifications;
    }
  },
  //commit => permite realizar una mutacion o acceder al state
  actions: {
    saveNotifications({ commit }, notifications) {
      localStorage.removeItem("notifications");
      commit("setNotifications", notifications);
      localStorage.setItem("notifications", JSON.stringify(notifications));
    },
    guardarUsuarioMenor({ commit }, data) {
      commit("setUsuarioMenor", data);
    },
    guardarToken({ commit }, data) {
      localStorage.removeItem("token");
      localStorage.removeItem("expiration");
      commit("setToken", jwt.decode(data.token, data.keyJwt));
      commit("setUsuario", jwt.decode(data.token, data.keyJwt));
      localStorage.setItem("token", data.token);
      let now = moment().format("DD/MM/YYYY h:mm");
      localStorage.setItem("expiration", now);
    },
    async autoLogin({ commit }, keyJwt) {
      let token = localStorage.getItem("token");
      let notifications = null;
      //let notifications = localStorage.getItem("notifications");

      if (token) {
        let student = jwt.decode(token, process.env.VUE_APP_JWT_TOKEN_KEY);

        if (student.has_debt) {
          let res = await axios.get(`users/user-has-debt/`, {
            headers: { Authorization: "Token " + student.token }
          });
          let data = await res.data;

          if (data) {
            student.has_debt = data.has_debt;
            student.url_image = data.url_image;
            student.has_debt_message = data.has_debt_message;

            localStorage.removeItem("token");
            commit("setToken", student);
            commit("setUsuario", student);
            localStorage.setItem(
              "token",
              jwt.encode(student, process.env.VUE_APP_JWT_TOKEN_KEY)
            );
          }
        } else {
          commit("setToken", jwt.decode(token, keyJwt));
          commit("setUsuario", jwt.decode(token, keyJwt));
        }
      } else {
        commit("setToken", null);
        commit("setUsuario", null);
        localStorage.removeItem("token");

        router.push("/login").catch(err => {});
      }

      if (notifications) {
        commit("setNotifications", JSON.parse(notifications));
      }
    },
    salir({ commit }) {
      commit("setToken", null);
      commit("setUsuario", null);
      commit("setUsuarioMenor", null);
      localStorage.removeItem("token");
      localStorage.removeItem("expiration");

      router.push("/login").catch(err => {});
      //location.reload();
    },

    async getTokenPayzen({ commit }, enrollment) {
      commit("setTokenPayzen", "");

      let res = await axios({
        method: "post",
        url: `users/payzen-token/`,
        data: enrollment,
        headers: {
          Authorization: "Token " + this.state.usuario.token
        }
      });

      let data = await res.data;
      let tp = null;

      if (data.token) {
        tp = await data.token;
      }

      commit("setTokenPayzen", tp);
    },

    async bankPayment({ commit }, enrollment) {
      let res = await axios({
        method: "post",
        url: `users/bank-payment/`,
        data: enrollment,
        headers: {
          Authorization: "Token " + this.state.usuario.token
        }
      });

      let data = await res.data;

      if (data) {
        commit("setBankPay", true);
      }
      commit("setBankPay", true);
    }
  },
  getters: {
    getToken: state => () => state.token,
    notifications: state => state.notifications
  },
  modules: {
    discuount,
    user,
    postulation
  }
});
